import { Trash2 } from "lucide-react"
import { Button } from "@/components/shadcn/button.tsx"

interface DeleteButtonProps {
  text: string
  onClick: () => void
  style?: React.CSSProperties
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  text,
  onClick,
  style,
}) => {
  return (
    <Button
      variant="outline"
      onClick={onClick}
      style={style}
      className="group mx-auto mb-[30px] mt-[7px] flex items-center gap-3 rounded-[20px] border-red-600 px-5 py-2.5 text-red-500 transition-colors [@media(hover:hover)]:hover:bg-red-600 [@media(hover:hover)]:hover:text-white"
    >
      <Trash2 className="h-4 w-4 transition-colors [@media(hover:hover)]:group-hover:text-white" />
      <span className="text-sm">{text}</span>
    </Button>
  )
}

export default DeleteButton
